'use strict'

module.exports = {
  DEFAULT_HTTP_API: '/ip4/127.0.0.1/tcp/5001'
}
